import ContatoInicialImg from '../images/contato_inicial.png'

export const templates = [
    {
        name: 'Contato Inicial',
        value: 'contato_inicial',
        img: ContatoInicialImg
    }
]